import React, { Component } from 'react';
import styled from '@emotion/styled';
import { Table, Input, Button, message } from 'antd';
import { Layout } from 'components';
import { Container, H2 } from 'utils';
import { getSettings, updateSetting } from 'services/SettingsService';

const PageWrapper = styled.div`
  padding: 24px 0;
`;

class AdminSettings extends Component {
  state = {
    loading: true,
    settings: [],
    values: {},
    savingKey: null,
  };

  componentDidMount() {
    this.fetchSettings();
  }

  fetchSettings = async () => {
    this.setState({ loading: true });
    try {
      const settings = await getSettings();
      const values = {};
      settings.forEach((setting) => {
        values[setting.key] = setting.value;
      });
      this.setState({ settings, values });
    } catch (error) {
      message.error('Einstellungen konnten nicht geladen werden.');
    } finally {
      this.setState({ loading: false });
    }
  };

  handleValueChange = (key, value) => {
    this.setState((prevState) => ({
      values: { ...prevState.values, [key]: value },
    }));
  };

  handleSave = async (key) => {
    this.setState({ savingKey: key });
    try {
      const { value } = await updateSetting(key, this.state.values[key]);
      this.setState((prevState) => ({
        values: { ...prevState.values, [key]: value },
      }));
      message.success('Einstellung gespeichert.');
    } catch (error) {
      message.error('Einstellung konnte nicht gespeichert werden.');
    } finally {
      this.setState({ savingKey: null });
    }
  };

  render() {
    const { loading, settings, values, savingKey } = this.state;

    const columns = [
      {
        title: 'Einstellung',
        dataIndex: 'label',
        key: 'label',
        width: '50%',
      },
      {
        title: 'Wert',
        key: 'value',
        render: (_, record) => (
          <Input
            value={values[record.key]}
            onChange={(e) => this.handleValueChange(record.key, e.target.value)}
          />
        ),
      },
      {
        title: '',
        key: 'actions',
        width: 140,
        render: (_, record) => (
          <Button
            type="primary"
            loading={savingKey === record.key}
            onClick={() => this.handleSave(record.key)}
          >
            Speichern
          </Button>
        ),
      },
    ];

    return (
      <Layout>
        <Container>
          <PageWrapper>
            <H2>Einstellungen</H2>
            <Table
              rowKey="key"
              columns={columns}
              dataSource={settings}
              loading={loading}
              pagination={false}
            />
          </PageWrapper>
        </Container>
      </Layout>
    );
  }
}

export default AdminSettings;
